module.exports = __webpack_public_path__ + "static/media/football-ball.0f331994.svg";